
const ContactHeroSection = () => {
  return (
    <section className="py-20 bg-navy">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="font-playfair text-5xl font-bold text-white mb-6">
          Let's Talk About Your Business
        </h1>
        <p className="text-xl text-gray-200 mb-8 leading-relaxed">
          Ready to explore your options? We're here to listen, answer your questions, and help you make the best decision for your future.
        </p>
      </div>
    </section>
  );
};

export default ContactHeroSection;
